<template>
  <div class="carPark-detail" :style="{height: height+'px'}">

    <loading v-if="loadingImg"></loading>
    <div v-else>
      <div v-if="!isPageError">
        <!-- 已缴费订单 start -->
        <div v-if="isConfim">
          <div class="top_title">
            <span class="text_bold">温馨提示：</span>
            付款成功后，请您在<span>15分钟</span>内驶离车场，否则您可能需要支付额外的超时费用。
          </div>

          <div class="confim_bottom">
            <div class="confim_bottom_title">

              <div class="confim_font">{{confimData.address}}</div>
              <div class="confim_text">支付成功</div>
            </div>

            <div class="confim_subTitle">
              <div class="item">车牌号：{{confimData.carPlate}}</div>
              <div class="item">订单号：{{confimData.orderSn}}</div>
            </div>

            <div class="item">
              <span class="item_time">进场时间</span>
              <span class="item_content">{{confimData.inTime | dCreateTime}}</span>
            </div>
            <div class="item">
              <span class="item_time">付款时间</span>
              <span class="item_content">{{confimData.endTime | dCreateTime}}</span>
            </div>
            <div class="item">
              <span class="item_time">收费规则</span>
              <span class="item_content">{{confimData.feeRule}}</span>
            </div>
            <div class="item">
              <span class="item_time">总费用</span>
              <span class="item_content">{{confimData.orderMoney / 100}}元</span>
            </div>
            <div class="item">
              <span class="item_time">支付状态</span>
              <span class="item_content">完成</span>
            </div>
            <div class="item">
              <span class="item_time">实际支付</span>
              <span class="item_content">{{confimData.payMoney / 100}}元</span>
            </div>
            <div class="item">
              <span class="item_time">支付渠道</span>
              <span class="item_content">{{confimData.payId == 1?'微信支付':confimData.payId == 2?'支付宝支付':'现金支付'}}</span>
            </div>
          </div>
        </div>
        <!-- 已缴费订单 end -->
        <!-- 未缴费订单 start -->
        <div v-if="!loadingImg && !isConfim">
          <div class="padding_container">
            <div class="topBox">
              <div class="item item_title">我的停车缴费信息
                <!-- (订单号：{{detailData.orderSn}}) -->
              </div>
              <div class="item item_num">
                <span class="span_title">车牌号</span>
                <span class="span_content">{{detailData.carPlate}}</span>
              </div>
              <div class="item item_park">
                <span class="span_title">停车场</span>
                <span class="span_content">{{detailData.address}}</span>
              </div>
              <div class="item item_inTime">
                <span class="span_title">车辆入场时间</span>
                <span class="span_content">{{detailData.inTime | dCreateTime}}</span>
              </div>
              <div class="item item_endTime">
                <span class="span_title">计费截止时间</span>
                <span class="span_content">{{detailData.endTime | dCreateTime}}</span>
              </div>
              <div class="item item_time">
                <span class="span_title">停车时长</span>
                <span class="span_content">{{inParkTime}}</span>
              </div>
              <div class="item item_rule">
                <span class="span_title">收费规则</span>
                <span class="span_content">{{detailData.feeRule}}</span>
              </div>
              <div class="item item_price">
                <span class="span_title">待缴停车费</span>
                <span class="span_content">{{this.detailData.payMoney / 100}}元</span>
              </div>
            </div>
            <div class="bottomBox">
              <div class="bottom_title">支付方式</div>
              <div class="bottom_choose">
                <van-radio-group v-model="radio">
                  <van-cell-group>
                    <van-cell class="cell_van" clickable @click="radio = '1'">
                      <template #title>
                        <div class="radio_item">
                          <div class="radio_leftPic">
                            <img class="radio_img" src="../../assets/img/wxPay_icon.png" alt="">
                          </div>
                          <div>
                            <div class="pay_Chinese">微信支付</div>
                            <div class="pay_English">WeChat Pay</div>
                          </div>
                        </div>
                      </template>
                      <template #right-icon>
                        <van-radio :icon-size="15" checked-color="#2EBA73" name="1" />
                      </template>
                    </van-cell>
                    <!-- <van-cell class="cell_van" clickable @click="radio = '2'">
                <template #title>
                  <span class="custom-title">支付宝支付</span>
                </template>
                <template #right-icon>
                  <van-radio :icon-size="15" checked-color="#188357" name="2" />
                </template>
              </van-cell> -->
                  </van-cell-group>
                </van-radio-group>
              </div>
              <div class="btnBox">
                <van-button color="#2EBA73" @click="confirmPay">确认支付</van-button>
              </div>
            </div>
          </div>
        </div>
        <!-- 未缴费订单 end -->
      </div>
      <page-error v-else></page-error>

    </div>

  </div>

</template>
<script>
import Loading from '@/components/loading';
import PageError from '../../components/PageError';
import Vue from 'vue';
import { RadioGroup, Radio } from 'vant';
Vue.use(Radio);
Vue.use(RadioGroup);
export default {
  data() {
    return {
      // 页面整体高度
      height: 0,
      // 1:微信支付  2:支付宝支付
      radio: '1',
      // 详情数据源
      detailData: {},
      loadingImg: true,
      // 是否为已缴费订单
      isConfim: false,
      // 已缴费详情数据
      confimData: {},
      isPageError: false,
      isFilter: true
    };
  },
  components: {
    Loading,
    PageError
  },
  mounted() {
    this.height = document.documentElement.clientHeight;
    if (this.$route.query.isConfim) {
      document.title = '停车缴费';
      this.isConfim = true;
      // console.log(this.$route.query.address,'address');
      // console.log(this.$route.query.carPlate,'carPlate');
      // console.log(this.$route.query.orderSn,'orderSn');
      // console.log(this.$route.query.inTime,'inTime');
      // console.log(this.$route.query.endTime,'endTime');
      // console.log(this.$route.query.feeRule,'feeRule');
      // console.log(this.$route.query.orderMoney,'orderMoney');
      // console.log(this.$route.query.payMoney,'payMoney');
      // console.log(this.$route.query.payId,'payId');
      this.confimData = {
        address: this.$route.query.address,
        carPlate: this.$route.query.carPlate,
        orderSn: this.$route.query.orderSn,
        inTime: this.$route.query.inTime,
        endTime: this.$route.query.endTime,
        feeRule: this.$route.query.feeRule,
        orderMoney: this.$route.query.orderMoney,
        payMoney: this.$route.query.payMoney,
        payId: this.$route.query.payId,
      }
      this.loadingImg = false;
    } else {
      document.title = '停车缴费';
      this.getDetailForId();
    }




  },
  methods: {
    // 获取详情页数据
    getDetailForId() {
      let formData = new FormData();
      formData.append('carPlate', this.$route.query.carPlate);
      this.$request.post(`/appserver/v1/carPark/getPayInfo`, formData).then(res => {
        if (res.data.data) {
          this.detailData = res.data.data;
          // this.detailData.endTime = null;
        } else {
          this.$toast(res.data.msg);
          this.isPageError = true;
        }

        this.loadingImg = false;
      }).catch(e => {
        this.$toast(e);
        this.isPageError = true;
      })
    },
    // 确认支付
    confirmPay() {
      // console.log(this.radio, 'radio');
      if (!this.isFilter) {
        console.log('节流');
        return;
      }
      this.isFilter = false;



      if (this.radio == 1) {   //微信支付
        let formData = new FormData();
        formData.append('carPlate', this.detailData.carPlate);
        formData.append('tradeType', '4');
        formData.append('openId', this.$cookie.get('w_open_id'));
        this.$request.post(`/appserver/v1/carPark/wxPay`, formData).then(res => {
          console.log(res.data.data, '统一下单接口');
          if (res.data.ret == 1) {
            if (res.data.errorcode == 6006) {
              this.$toast('支付成功!');
              this.isFilter = true;

              this.$router.replace({
                path: '/carParkResult',
                query: {
                  orderNo: this.detailData.orderNo,
                  carPlate: this.detailData.carPlate
                }
              })
            } else {
              this.isFilter = true;
              this.$toast(res.data.msg)
            }
          } else {
            let data = res.data.data;
            // this.$router.replace({
            //   path: '/carParkResult',
            //   query: {
            //     orderNo: this.detailData.orderId,
            //     carPlate: this.detailData.carPlate
            //   }
            // })
            console.log(data.appid, 'data.appid');
            console.log(data.timestamp, 'data.timestamp');
            console.log(data.noncestr, 'data.noncestr');
            console.log(data.packages, 'data.packages');
            console.log(data.signType, 'data.signType');
            console.log(data.sign, 'data.sign');
            // return;
            this.isFilter = true;
            wx.chooseWXPay({
              appId: data.appid,
              timestamp: data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: data.noncestr, // 支付签名随机串，不长于 32 位
              package: data.packages, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: data.sign, // 支付签名
              success: (res) => {
                // 支付成功后的回调函数
                console.log('支付成功', res);
                if (res.err_msg) {
                  this.$toast(res.err_msg);
                } else {  // 支付成功
                  this.$router.replace({
                    path: '/carParkResult',
                    query: {
                      orderNo: this.detailData.orderNo,
                      carPlate: this.detailData.carPlate
                    }
                  })
                }
                // if (res.err_msg == "get_brand_wcpay_request:ok") {
                //   this.$router.replace({
                //     path: '/carParkResult',
                //     query: {
                //       orderNo: this.detailData.orderNo,
                //       carPlate: this.detailData.carPlate
                //     }
                //   })
                // } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                //   this.$toast('支付取消');
                // } else {
                //   this.$toast('支付失败' + res.err_msg);
                // }

              },
              fail: (res) => {
                // console.log('支付失败', res);
                this.$toast('发起微信支付失败' + JSON.stringify(res));
              }
            });
          }

        })
      } else if (this.radio == 2) {   //支付宝支付

      }

    }

  },
  computed: {
    // 停车时长
    inParkTime: function () {
      if (this.detailData.inTime && this.detailData.endTime) {
        let s1 = new Date(this.detailData.inTime);
        let s2 = new Date(this.detailData.endTime);
        let runTime = parseInt((s2.getTime() - s1.getTime()) / 1000);
        let year = Math.floor(runTime / 86400 / 365);
        runTime = runTime % (86400 * 365);
        let month = Math.floor(runTime / 86400 / 30);
        runTime = runTime % (86400 * 30);
        let day = Math.floor(runTime / 86400);
        runTime = runTime % 86400;
        let hour = Math.floor(runTime / 3600);
        runTime = runTime % 3600;
        let minute = Math.floor(runTime / 60);
        runTime = runTime % 60;
        let second = runTime;
        let str = '';
        if (second) {
          str = second + '秒';
        }
        if (minute > 0 || hour > 0 || day > 0 || month > 0 || year > 0) {
          str = minute + '分' + str;
        }
        if (hour > 0 || day > 0 || month > 0 || year > 0) {
          str = hour + '小时' + str;
        }
        if (day > 0 || month > 0 || year > 0) {
          str = day + '天' + str;
        }
        if (month > 0 || year > 0) {
          str = month + '月' + str;
        }
        if (year > 0) {
          str = year + '年' + str;
        }
        return str;
      } else {
        return '未知'
      }

    }
  },
  filters: {
    // 时间戳过滤为日期
    dCreateTime(value) {
      if (value) {
        var date = new Date(parseInt(value));
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = date.getDate() + ' ';
        var h = (date.getHours() >= 10 ? date.getHours() : '0' + date.getHours()) + ':';
        var m = (date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes()) + ':';
        var s = (date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds());
        // h = (Number(h) >= 10 ? h : '0' + h);
        // m = (Number(m) >= 10 ? m : '0' + m);
        // s = (Number(s) >= 10 ? s : '0' + s);
        var df = Y + M + D + h + m + s;
        console.log(h, 'dfdfdf')
        return df;
      } else {
        return '未知';
      }

    },
  }
};
</script>
<style lang="scss" scoped>
.carPark-detail {
  overflow: auto;
  background: white;
  color: #333;
  // padding: 0 20px;
  letter-spacing: 0.5px;
  .padding_container {
    padding: 0 20px;
  }
  .topBox {
    margin-top: 10px;
    width: 100%;
    // height: 50%;
    font-size: 13px;
    border-bottom: 10px solid #f5f5f5;
    .item {
      margin-bottom: 10px;
      .span_title {
        width: 30%;
        height: 100%;
        display: inline-block;
      }
      .span_content {
        width: 70%;
      }
    }
    .item_title {
      font-weight: bold;
      color: black;
    }
    .item_price {
      color: #2eba73;
      .span_title {
        color: #262626;
      }
    }
  }
  .bottomBox {
    margin-top: 30px;
    .bottom_title {
      font-size: 15px;
      font-weight: bold;
    }
    .bottom_choose {
      margin-top: 15px;
      .radio_item {
        display: flex;
        align-items: center;
        // border-bottom: 1px solid #dedede;
        padding: 10px 0px;

        .radio_leftPic {
          margin-right: 15px;
          width: 35px;
          height: 35px;
          .radio_img {
            width: 100%;
            height: 100%;
          }
        }
        .pay_English {
          font-size: 12px;
          color: #333;
        }
        .pay_Chinese {
          font-weight: bold;
          color: black;
        }
      }
    }
    .btnBox {
      display: flex;
      flex-direction: cloumn;
      justify-content: center;
      margin-top: 30px;
      padding-bottom: 30px;
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 90vw;
      transform: translateX(-50%);
    }
  }

  .top_title {
    font-size: 12px;
    letter-spacing: 0.5px;
    // border-bottom: 10px solid #f5f5f5;
    background: #ffebd3;
    color: #ff9b24;
    font-size: 12px;
    padding: 10px 20px;
    .text_bold {
      // font-weight: bold;
      // font-size: 13px;
    }
  }

  .confim_bottom {
    margin-top: 20px;
    color: #333;
    line-height: 30px;
    padding: 0 20px;
    .confim_bottom_title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .confim_text {
        margin-right: 10px;
        padding: 0px 10px;
        color: #2eba73;
        background: rgba(46, 186, 115, 0.1);
        font-size: 12px;
      }
      .confim_font {
        font-weight: 700;
        font-size: 16px;
        color: #262626;
      }
    }
    .confim_subTitle {
      padding: 10px 0px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 20px;
      .item {
        color: #262626;
        font-size: 15px;
      }
    }
    .item {
      font-size: 14px;
      .item_time {
        display: inline-block;
        min-width: 70px;
        color: #787878;
      }
    }
  }
}
</style>
<style lang="scss">
.carPark-detail {
  .cell_van {
    padding-left: 0;
    padding-right: 0;
  }
  .bottomBox {
    .btnBox {
      .van-button--normal {
        width: 100%;
      }
    }
  }
}
</style>
